import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getMaturityEvaluation } from "@/api/endpoints/maturity";

export function useGetMaturityEvaluation(sessionId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.maturity.evaluation(sessionId || ""),
    queryFn: () => getMaturityEvaluation(sessionId!),
    staleTime: 30_000,
    enabled: !!sessionId,
  });
}
